module.exports = __webpack_public_path__ + "static/media/zoomin.f0b6e6fe.svg";